<template>
  <svg xmlns="http://www.w3.org/2000/svg" class="color/all" width="24" height="24">
  </svg>
</template>

<script>
export default {
}
</script>
